import { onReady } from './util/onReady';

onReady(() => {
    setupToggle();
});

function setupToggle() {
    const nvaContainer = document.querySelector('.nva-projects');
    if (!nvaContainer) return;

    const accordions = nvaContainer.querySelectorAll('.accordion-content');

    accordions.forEach((accordion) => {
        const teaser = accordion.querySelector<HTMLElement>('.accordion-teaser');
        const button = accordion.querySelector<HTMLButtonElement>('.accordion-button-container');

        if (!teaser || !button) return;

        // Check if teaser is visually truncated
        const isTeaserClamped = teaser.scrollHeight > teaser.clientHeight;

        // Show or hide button based on conditions
        if (isTeaserClamped) {
            button.style.display = 'flex';
        } else {
            button.style.display = 'none';
        }

        button.addEventListener('click', () => {
            teaser.classList.toggle('show');
            const isExpanded = teaser.classList.contains('show');
            button.setAttribute('aria-expanded', isExpanded.toString());
            const newLabel = isExpanded ? button.dataset.hideSummary : button.dataset.showSummary;
            if (newLabel) button.setAttribute('aria-label', newLabel);
        });
    });
}
